export const getUserIpAddress = async (): Promise<string> => {
  try {
    // Use a public API to get the client's IP address
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.error('Error fetching IP address:', error);
    return 'unknown-ip';
  }
};
